import React from "react";

const Rules = () => (
  <div className="rules-page">
    <h1>Fantasy Swim League Rules</h1>

    <div className="rules-alert-box">
      <strong>Important:</strong> All rules are subject to change at any moment
      during the game.
    </div>

    <h2>General Rules</h2>
    <ul>
      <li>
        Do not tell any children or parents about this game that we are playing.
      </li>
      <li>
        This is meant to help everyone become better teachers and motivators in
        a fun and exciting way.
      </li>
      <li>
        Don&apos;t just pick favorites. This game is meant to help you stay
        motivate in becoming the best coach you can be; picking favorites can
        cause you to focus on one student rather than helping them all.
      </li>
      <li>No picking your siblings.</li>
    </ul>

    <h2>Rules of the Draft</h2>
    <ul>
      <li>
        Drafting will be a randomly selected order and then follow a snake draft
        pattern.
      </li>
      <li>Only swimmers age 14 and under are part of the fantasy game.</li>
      <li>Every team must keep 1 active swimmer in each required slot:</li>
      <li>6 &amp; under girl / 6 &amp; under boy</li>
      <li>7-8 girl / 7-8 boy</li>
      <li>9-10 girl / 9-10 boy</li>
      <li>11-12 girl / 11-12 boy</li>
      <li>13-14 girl / 13-14 boy</li>
      <li>
        Any extra eligible swimmers on your roster stay on the bench until you
        move them into an active slot.
      </li>
      <li>
        You may move swimmers between the active lineup and bench until the game
        is locked.
      </li>
      <li>
        Once the game is locked, no active-lineup changes can be made until it
        is unlocked.
      </li>
      <li>
        After the draft is completed you may trade swimmers with any coach if
        both parties consent.
      </li>
      <li>All trades must be approved by Coach Peyton.</li>
    </ul>

    <h2>Ways to Win</h2>
    <p>There are two independent ways to win the season. You can win either one, both, or neither.</p>
    <ul>
      <li>
        <strong>Most Overall Points:</strong> The coach with the highest cumulative fantasy points at the end of the season wins. Every swimmer on your active roster contributes to this total across all scored meets.
      </li>
      <li>
        <strong>Swiss Bracket Champion:</strong> Each meet, you face a head-to-head matchup against another coach. Your bracket score is determined by your top 3 boys and top 3 girls by points at that meet (6 swimmers total). The coach with the higher bracket score wins the week. Coaches with the same win-loss record are matched against each other each week — everyone keeps playing all season, no one is eliminated. The coach with the best record at the end of all meets wins the bracket.
        <ul>
          <li>In the event of a tie after 6 swimmers, the matchup is decided by top 4 boys + top 4 girls (8 swimmers total).</li>
          <li>If still tied after 8 swimmers, the result is recorded as a draw (0.5 wins each).</li>
          <li>The first meet of the season is a baseline meet — no bracket scoring occurs. Swimmers must have swum at least once before in order to score points in future meets.</li>
        </ul>
      </li>
    </ul>

    <h2>Scoring</h2>
    <ul>
      <li>There are 3 categories for scoring.</li>
      <li>
        Category 1: Overall time drops, 4 points per second dropped (including
        decimals). Example: 0.8 drop = 3.2 points.
      </li>
      <li>
        Category 2: Level system scoring, 3 points per learned skill and 25
        points per level increased. You will select 1 swimmer per gender, per
        age group. They will be evaluated at the beginning of the season and
        then again at the end of the season. The difference in points from the
        two evaluations will be added to your score. Example: If a swimmer
        learns 10 new skills and increases 2 levels, that would be 3*10 + 2*25 =
        80 points.
      </li>
      <li>
        These first two categories mean the fastest swimmer is not necessarily
        the best draft pick.
      </li>
      <li>
        Category 3: Points earned for the Greenbrook team in individual events.
        This gives faster swimmers more value, but gives fewer points than the
        other two categories.
        <ul>
          <li>1st place - 7 pts</li>
          <li>2nd place - 4 pts</li>
          <li>3rd place - 3 pts</li>
          <li>4th place - 2 pts</li>
          <li>5th place - 1 pt</li>
        </ul>
      </li>
      <li>
        A swimmer might also add time, but if they get first place, they would
        still earn points for your fantasy team.
      </li>
      <li>
        Picking a swimmer with weaker form and slower times may leave more
        potential for higher points.
      </li>
      <li>
        Only swimmers in your active lineup count as your active team for the
        current lock period.
      </li>
      <li>
        Swimmers will be evaluated by Jake, Peyton, Kelsey, or Kyle for
        level-system improvement.
      </li>
      <li>
        All scoring from these evaluations will be manually updated at the end
        of the season.
      </li>
    </ul>
  </div>
);

export default Rules;
